export enum Environments {
  PRODUCTION = 'production',
  SANDBOX = 'sandbox'
}
